/**
 * Display helpers for login `data.user`: firstName, lastName, email, role.
 */

export function getUserDisplayName(user) {
  if (!user || typeof user !== "object") return "User";
  const fn = String(user.firstName ?? "").trim();
  const ln = String(user.lastName ?? "").trim();
  const combined = [fn, ln].filter(Boolean).join(" ");
  if (combined) return combined;
  const jwtName = typeof user.name === "string" ? user.name.trim() : "";
  if (jwtName) return jwtName;
  const email = String(user.email ?? "").trim();
  if (email) return email;
  return "User";
}

export function getUserAvatarInitials(user) {
  if (!user || typeof user !== "object") return "?";
  const fn = String(user.firstName ?? "").trim();
  const ln = String(user.lastName ?? "").trim();
  if (fn && ln) return `${fn[0]}${ln[0]}`.toUpperCase();
  if (fn.length >= 2) return fn.slice(0, 2).toUpperCase();
  if (fn.length === 1) return fn.toUpperCase();
  const email = String(user.email ?? "").trim();
  if (email.length >= 2) return email.slice(0, 2).toUpperCase();
  return "?";
}

export function formatRoleLabel(role) {
  const r = String(role ?? "").trim();
  switch (r) {
    case "assetOwner":
      return "Asset Owner";
    case "investor":
      return "Investor";
    case "admin":
      return "Administrator";
    default:
      if (!r) return "";
      return r
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (s) => s.toUpperCase())
        .trim();
  }
}
